import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_AMBER } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/cradles.onsets.json' with { type: 'json' };
import normalImported from './imported/cradles-normal.circles.json' with { type: 'json' };
import hardImported from './imported/cradles-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/cradles-extreme.circles.json' with { type: 'json' };

export const CRADLES_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'cradles',
  baseTitle: "Cradles",
  description: "Sub Urban's dark alt-pop. Snappy snares and vocal-led groove, full song this time.",
  difficulty: 3,
  palette: PALETTE_AMBER,
  audioSrc: '/audio/circles/cradles.mp3',
  attribution: "\"Cradles\" by Sub Urban [NCS Release] - https://ncs.io/Cradles",
  mapper: "DaKawaliKid",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 80, offsetMs: 0, totalBeats: 83 },
    hard: { bpm: 80, offsetMs: 0, totalBeats: 83 },
    extreme: { bpm: 80, offsetMs: 0, totalBeats: 83 },
  },
});
